module.exports = __webpack_public_path__ + "img/gr.6fdbfb3f.png";